import { config } from './config';

// Type declarations for global analytics functions
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
  }
}

interface TrackingProperties {
  [key: string]: string | number | boolean | undefined;
}

/**
 * Track event to Google Analytics 4
 */
export function trackGA4Event(eventName: string, properties: TrackingProperties = {}): void {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, {
      ...properties,
      page_title: document.title,
      page_location: window.location.href,
      timestamp: new Date().toISOString()
    });
  }
  console.log('GA4 Event:', eventName, properties);
}

/**
 * Track event to Facebook Pixel
 */
export function trackFacebookEvent(eventName: string, properties: TrackingProperties = {}): void {
  if (typeof window.fbq !== 'undefined') {
    window.fbq('track', eventName, properties);
  }
  console.log('Facebook Event:', eventName, properties);
}

/**
 * Track conversion to Google Ads
 */
export function trackGoogleAdsEvent(eventName: string, value: number = 1): void {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      send_to: config.analytics.googleAdsConversionId,
      event_category: 'conversion',
      event_label: eventName,
      value
    });
  }
}

/**
 * Track WhatsApp button click
 */
export function trackWhatsAppClick(buttonLocation: string): void {
  trackGA4Event('whatsapp_click', { button_location: buttonLocation });
  trackFacebookEvent('Lead', { content_name: 'WhatsApp Click' });
  trackGoogleAdsEvent('WhatsApp', 10);
}

/**
 * Track phone call click
 */
export function trackPhoneCallClick(buttonLocation: string): void {
  trackGA4Event('phone_call', { button_location: buttonLocation });
  trackGoogleAdsEvent('Phone Call', 15);
}

/**
 * Track form submission
 */
export function trackFormSubmission(formType: string, pageUrl: string): void {
  trackGA4Event('form_submission', { form_type: formType, page_url: pageUrl });
  trackFacebookEvent('Lead', { content_name: `${formType} Form` });
  trackGoogleAdsEvent('Form Submission', 20);
}

/**
 * Track page view
 */
export function trackPageView(): void {
  trackGA4Event('page_view', {
    page_title: document.title,
    page_location: window.location.href
  });
}

/**
 * Initialize all tracking for a page
 */
export function initPageTracking(): void {
  trackPageView();

  // Track WhatsApp links
  document.querySelectorAll('a[href*="whatsapp"]').forEach((link) => {
    link.addEventListener('click', () => {
      trackWhatsAppClick(window.location.href);
    });
  });

  // Track phone links
  document.querySelectorAll('a[href^="tel:"]').forEach((link) => {
    link.addEventListener('click', () => {
      trackPhoneCallClick(window.location.href);
    });
  });
}
